import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const base_url = `${ environment.base_url }/Proveedores`;


@Injectable({
  providedIn: 'root'
})
export class ProveedoresService {
  token:string = localStorage.getItem('tp-Token') || '';
  headers = new HttpHeaders({
    'Content-Type':'application/x-www-form-urlencoded',
    'Tp-Token': localStorage.getItem('tp-Token') || ''
  });

  constructor(private http: HttpClient) { }

  getProveedorCodigo(codigo:string){
    const url = `${ base_url }/getProveedorCodigo/${codigo}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  encriptarCuentasProveedores(){
    const url = `${ base_url }/encriptarCuentasProveedores`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getProveedorId(id:number){
    const url = `${ base_url }/getProveedorId/${id}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  nuevo(data:string){
    const url = `${ base_url }/postProveedor`;
    // console.log(url);
    
    return this.http.post(url, data, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  actualizar(data:string, id:number){
    const url = `${ base_url }/putProveedor/${id}`;
    // console.log(url);
    
    return this.http.put(url, data, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  busqueda(valor:string, pagina:number, rows:number){
    const url = `${ base_url }/getBusquedaProveedor/${valor}?page=${pagina}&rows=${rows}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getAll(pagina:number, rows:number, desdeCodigo:string, hastaCodigo:string, desdeNombreFiscal:string, hastaNombreFiscal:string, desdeNombreComercial:string, hastaNombreComercial:string, bloqueados:boolean, orden:string, desc:number){
    const url = `${ base_url }/getAll?page=${pagina}&rows=${rows}&decli=${desdeCodigo}&hacli=${hastaCodigo}&defis=${desdeNombreFiscal}&hafis=${hastaNombreFiscal
                             }&decom=${desdeNombreComercial}&hacom=${hastaNombreComercial}&bloq=${bloqueados}&order=${orden}&desc=${desc}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getCombo(orden:string, bloqueados: boolean = false){
    const url = `${ base_url }/getAll?&order=${orden}&bloq=${bloqueados}`;
    // console.log(url);
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          // console.log(resp);
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

   cambiarCodigoProveedor(oldCodigo: string, newCodigo: string){
     const url = `${ base_url }/cambiarCodigoProveedor/${oldCodigo}/${newCodigo}`;
     
     return this.http.get(url, {headers: this.headers})
                     .pipe(
                       map(
                         (resp:any)=>{
                           // console.log(resp);
                           const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                           
                           return respuesta;
                         }
                       )
                     )
                     ;
   }

   getNextProveedorCodigo(){
       const url = `${ base_url }/getNextProveedorCodigo`;
       
       return this.http.get(url, {headers: this.headers})
                       .pipe(
                         map(
                           (resp:any)=>{
                             const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                             return respuesta;
                           }
                         )
                       )
                       ;
     }


}
